<template>
    <div v-show="toggleLightbox" class="lightbox">
        <div class="lightbox-box" :class="customClass">
            <button class="lightbox-close-btn" @click="toggleLightbox = false">+</button>
            <slot></slot>
        </div>
    </div>
</template>

<script>
import { EventBus } from "../event-bus";

export default {
  name: 'Lightbox',
  data() {
    return {
        toggleLightbox: false,
    }
  },
  props: {
    'activateCommand': String,
    'deactivateCommand': String,
    'customClass': String,
  },
  created(){
    EventBus.$on(this.activateCommand, () =>{
        this.toggleLightbox = true;
    });
    EventBus.$on(this.deactivateCommand, () =>{
        this.toggleLightbox = false;
    });
  }



}
</script>

<style scoped>

</style>